import {Vnode} from 'mithril';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import UserPage from 'flarum/forum/components/UserPage';
import User from 'flarum/common/models/User';
import LinkedFormFill from '../components/LinkedFormFill';
import Form from '../models/Form';
import isHorizontalLayout from '../utils/isHorizontalLayout';

export default class ProfilePage extends UserPage {
    form: Form | null = null

    oninit(vnode: Vnode) {
        super.oninit(vnode);

        this.loadUser(m.route.param('username'));
    }

    show(user: User) {
        // The form should already be in the store because it's a user relation
        // We can simply look by slug because the slug will contain the UID if there is no slug
        // We need to do this in show() because the data will only be added to the store once the user was loaded by loadUser()
        const seoId = m.route.param('form');
        this.form = app.store.getBy<Form>('formulaire-forms', 'seoId', seoId) || null;

        // Call super.show afterwards, since it will trigger a redraw
        super.show(user);
    }

    content() {
        return this.form ? m(LinkedFormFill, {
            // Necessary to force the fields to re-render when switching between multiple forms in profile
            key: this.form.id(),
            form: this.form,
            linked: this.user,
            className: isHorizontalLayout(this.form.attribute('canSubmit') ? 'ProfileEdit' : 'ProfileView') ? 'Formulaire-horizontal-layout' : '',
        }) : LoadingIndicator.component();
    }
}
